"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.debounce")),
    _Error = _interopRequireDefault(require("../../Error")),
    _utils = require("../utils"),
    _AssetsList = _interopRequireDefault(require("./AssetsList")),
    _ManageAssetModal = _interopRequireDefault(require("../../ManageAssetModal")),
    _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal")),
    _confirmActions = _interopRequireDefault(require("./ConfirmationModal/constants/confirmActions"));

require("../styles/_library.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var CHUNK_SIZE = 16,
    AssetLibrary = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.showConfirmationModal = function (a) {
      var b = a.assetId,
          c = a.confirmModalAction;
      d.setState({
        isConfirmModalOpen: !0,
        confirmModalAction: c,
        assetId: b
      });
    }, d.fetchAssets = function () {
      d.setState({
        loading: !0
      }, (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
        var b, c, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
        return _regenerator["default"].wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                return b = d.props, c = b.assetsMap, e = b.getAssetSummariesAndCount, f = b.organisationId, g = d.state, h = g.archivedFilter, i = g.searchTerm, j = g.offset, k = g.limit, l = "ARCHIVED" === h, a.next = 5, e({
                  offset: j,
                  limit: k,
                  search: i,
                  isArchived: l
                });

              case 5:
                if (m = a.sent, n = m.data, o = void 0 === n ? {} : n, p = m.error, !p && o) {
                  a.next = 11;
                  break;
                }

                return a.abrupt("return", void d.setState({
                  loading: !1,
                  error: p
                }));

              case 11:
                if (q = o.getAssetSummariesAndCount, r = q.count, s = void 0 === r ? 0 : r, t = q.assets, u = void 0 === t ? [] : t, !p) {
                  a.next = 14;
                  break;
                }

                return a.abrupt("return", void d.setState({
                  error: p
                }));

              case 14:
                v = u.map(function (a) {
                  return _objectSpread(_objectSpread({}, a), {}, {
                    assetFiles: _objectSpread(_objectSpread({}, a.assetFiles), {}, {
                      SD: {},
                      HD: {},
                      STREAM: {
                        fragments: []
                      }
                    })
                  });
                }), w = (0, _utils.mergeAssets)(c, v, f), d.setState(function (a) {
                  return _objectSpread(_objectSpread({}, a), {}, {
                    totalResults: s,
                    assets: w,
                    loading: !1,
                    offset: j + a.limit,
                    limit: CHUNK_SIZE
                  });
                });

              case 17:
              case "end":
                return a.stop();
            }
          }
        }, a);
      })));
    }, d.componentDidMount = function () {
      d.fetchAssets();
    }, d.updateAssets = function (a) {
      var b = d.props.organisationId;
      d.setState(function (c) {
        var d = c.assets;
        return _objectSpread(_objectSpread({}, c), {}, {
          assets: (0, _utils.mergeAssets)(a, d, b)
        });
      });
    }, d.componentDidUpdate = function (a) {
      var b = a.assetsMap,
          c = a.organisationId,
          e = d.props,
          f = e.assetsMap,
          g = e.organisationId;
      return b === f ? c === g ? void 0 : void d.fetchAssets() : void d.updateAssets(f);
    }, d.closeConfirmationModal = function () {
      d.setState({
        isConfirmModalOpen: !1
      });
    }, d.showManageAssetModal = function (a) {
      var b = a.assetId;
      d.setState({
        isManageAssetModalVisible: !0,
        assetId: b
      });
    }, d.closeManageAssetModal = function () {
      d.setState({
        isManageAssetModalVisible: !1
      });
    }, d.setFilePickerRef = function (a) {
      d._filePickerRef = a;
    }, d.handleUploadClick = function () {
      d._filePickerRef && d._filePickerRef.openFileChooser();
    }, d.handleManageAssetModalSave = function (a) {
      d.setState(function (b) {
        var c = b.assets;
        return {
          assets: (0, _utils.replaceAsset)(c, a.updateAsset)
        };
      });
    }, d.handleModalConfirmation = function () {
      var a = d.props.removeFromAssetsMap,
          b = d.state,
          c = b.assetId,
          e = b.confirmModalAction;
      Object.values(_confirmActions["default"]).includes(e) && (d.setState(function (a) {
        var b = a.assets;
        return {
          assets: (0, _utils.removeAsset)(b, c)
        };
      }), a(c)), d.closeConfirmationModal();
    }, d.onDeleteComplete = function (a) {
      var b = d.props.removeFromAssetsMap;
      d.setState(function (b) {
        var c = b.assets;
        return {
          assets: (0, _utils.removeAsset)(c, a)
        };
      }), b(a);
    }, d.handleFilterChange = function (a) {
      var b = a.filters.ARCHIVED_FILTER,
          c = a.searchTerm,
          e = d.state,
          f = e.archivedFilter,
          g = e.searchTerm;
      f === b && g === c || d.setState({
        offset: 0,
        limit: 32,
        showingNum: CHUNK_SIZE,
        searchTerm: c,
        archivedFilter: b,
        assets: [],
        loading: !0
      }, function () {
        return d.fetchAssets();
      });
    }, d.getFilteredAssets = function () {
      var a = d.state,
          b = a.assets,
          c = void 0 === b ? [] : b,
          e = a.searchTerm;
      return c ? e ? c.filter(function (a) {
        return Object.values(a).some(function (a) {
          return a && "string" == typeof a && a.toLowerCase().includes(e.toLowerCase());
        });
      }) : c : [];
    }, d.handleDragOver = function (a) {
      a.preventDefault();
    }, d.handleDragLeave = function (a) {
      a && null !== a.relatedTarget || d.setState({
        dropZoneDisplayed: !1
      });
    }, d.handleDragEnter = function () {
      d.setState({
        dropZoneDisplayed: !0
      });
    }, d.closeDropZone = function (a) {
      a.preventDefault(), d.setState({
        dropZoneDisplayed: !1,
        offset: 0,
        limit: 32,
        showingNum: CHUNK_SIZE,
        searchTerm: "",
        archivedFilter: "ACTIVE",
        assets: [],
        loading: !0
      }, function () {
        return d.fetchAssets();
      });
    }, d.showMore = function () {
      var a = d.state,
          b = a.showingNum,
          c = a.totalResults;
      b >= c || d.setState(function (a) {
        return _objectSpread(_objectSpread({}, a), {}, {
          showingNum: a.showingNum + CHUNK_SIZE
        });
      });
    }, d.loadMore = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              if (b = d.state, c = b.archivedFilter, e = b.searchTerm, f = b.offset, g = b.limit, h = b.assets, i = b.totalResults, !(h && h.length >= i)) {
                a.next = 3;
                break;
              }

              return a.abrupt("return");

            case 3:
              return j = d.props, k = j.assetsMap, l = j.getAssetSummariesAndCount, m = j.organisationId, n = "ARCHIVED" === c, a.next = 7, l({
                offset: f,
                limit: g,
                search: e,
                isArchived: n
              });

            case 7:
              if (o = a.sent, p = o.data, q = void 0 === p ? {} : p, r = o.error, s = q.getAssetSummariesAndCount, t = s.count, u = void 0 === t ? 0 : t, v = s.assets, w = void 0 === v ? [] : v, !r) {
                a.next = 14;
                break;
              }

              return a.abrupt("return", void d.setState({
                error: r
              }));

            case 14:
              x = w.map(function (a) {
                return _objectSpread(_objectSpread({}, a), {}, {
                  offset: f + CHUNK_SIZE,
                  totalResults: u,
                  assetFiles: _objectSpread(_objectSpread({}, a.assetFiles), {}, {
                    SD: {},
                    HD: {},
                    STREAM: {
                      fragments: []
                    }
                  })
                });
              }), y = (0, _utils.mergeAssets)(k, x, m), d.setState(function (a) {
                return _objectSpread(_objectSpread({}, a), {}, {
                  assets: [].concat((0, _toConsumableArray2["default"])(a.assets || []), (0, _toConsumableArray2["default"])(y)),
                  loading: !1,
                  offset: f + a.limit
                });
              });

            case 17:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.needMore = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              d.showMore(), d.loadMore();

            case 2:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.removeDuplicateAssets = function (a) {
      if (!a) return a;
      var b = new Set();
      return a.filter(function (a) {
        var c = a.assetId,
            d = b.has(c);
        return b.add(c), !d;
      });
    }, d.setListRef = function (a) {
      a && (d._listRef = a);
    }, d.getListRef = function () {
      return d._listRef;
    }, d.state = {
      isManageAssetModalVisible: !1,
      isConfirmModalOpen: !1,
      confirmModalAction: "",
      assetId: "",
      assets: void 0,
      loading: !0,
      dropZoneDisplayed: !1,
      archivedFilter: "",
      offset: 0,
      limit: 32,
      showingNum: CHUNK_SIZE,
      totalResults: 0
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.history,
          c = a.organisationName,
          d = a.deleteAsset,
          e = a.orgPermissions,
          f = a.isListEditable,
          g = a.showActiveFilter,
          h = a.listProps,
          i = this.state,
          j = i.isManageAssetModalVisible,
          k = i.assetId,
          l = i.confirmModalAction,
          m = i.isConfirmModalOpen,
          n = i.loading,
          o = i.dropZoneDisplayed,
          p = i.archivedFilter,
          q = i.error,
          r = i.totalResults,
          s = i.offset,
          t = i.limit,
          u = i.showingNum;
      if (q) return _react["default"].createElement(_Error["default"], null);
      var v = this.removeDuplicateAssets(this.getFilteredAssets()),
          w = Math.min(r, s + t),
          x = v.length;
      return _react["default"].createElement("div", {
        className: "library",
        onDrop: this.closeDropZone,
        onDragLeave: this.handleDragLeave,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragOver,
        ref: this.setListRef
      }, _react["default"].createElement(_AssetsList["default"], {
        assets: v.slice(0, u),
        history: b,
        showConfirmationModal: this.showConfirmationModal,
        showModal: this.showManageAssetModal,
        setFilePickerRef: this.setFilePickerRef,
        handleFilterChange: (0, _lodash["default"])(this.handleFilterChange, 500),
        loading: n,
        dropZoneDisplayed: o,
        closeDropZone: this.handleDragLeave,
        archivedFilter: p,
        deleteAsset: d,
        onDeleteComplete: this.onDeleteComplete,
        orgPermissions: e,
        loadMoreResults: this.needMore,
        totalResults: r - (w - x),
        getListRef: this.getListRef,
        isListEditable: void 0 === f || f,
        showActiveFilter: void 0 === g || g,
        listProps: h
      }), _react["default"].createElement(_ManageAssetModal["default"], {
        assetId: k,
        isVisible: j,
        onClose: this.closeManageAssetModal,
        onSave: this.handleManageAssetModalSave
      }), _react["default"].createElement(_ConfirmationModal["default"], {
        organisationName: c,
        visible: m,
        hideModal: this.closeConfirmationModal,
        assetId: k,
        confirmModalAction: l,
        onConfirmation: this.handleModalConfirmation
      }));
    }
  }]), b;
}(_react.Component);

exports["default"] = AssetLibrary;